const PortfolioIndex =
{
  portfolio1: 
  {
    id          : 1,
    credits     : ['pmjarquitectos', 'entornoceo', 'lightitbe'],
  },
  portfolio2: 
  {
    id          : 2,
    credits     : ['pmjarquitectos', 'entornoceo', 'lightitbe'],
  },
  portfolio3: 
  {
    id          : 3,
    credits     : ['pmjarquitectos', 'entornoceo', 'lightitbe'],
  },
  portfolio4: 
  {
    id          : 4,
    credits     : ['pmjarquitectos', 'arbuconstructora', 'entornoceo', 'lightitbe'],
  },
  portfolio5: 
  {
    id          : 5,
    credits     : ['pmjarquitectos', 'entornoceo', 'lightitbe'],
  },
  portfolio6: 
  {
    id          : 6,
    credits     : ['pmjarquitectos', 'entornoceo', 'lightitbe'],
  }, 
}

export default PortfolioIndex;